module.exports = __webpack_public_path__ + "static/media/SaladHomePage.3d5817b0.jpg";